<template>
  <div>
    <v-dialog
      v-model="dialog_book_setting"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">
          ตั้งค่าหนังสือขาย
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_book_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card class="pt-2 my-3 mt-6" outlined>
            <v-card-title class="justify-center main-title pb-0">หนังสือขายทั้งหมด</v-card-title>

            <v-data-table :headers="book_headers" :items="detail_book">
              <!-- dialog -->
              <template v-slot:top>
                <v-col align="right">
                  <v-btn @click="dialogAddEdit('')" color="primary" dark class="btn-responsive">
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>เพิ่มหนังสือขาย
                  </v-btn>
                </v-col>

                <v-dialog
                  v-model="dialog"
                  width="700"
                  persistent
                  content-class="alldialog_settings"
                >
                  <v-card>
                    <v-card-title style="background-color:rgba(227, 236, 238, 0.9);">
                      <span class="main-subtitle pb-2">{{ formTitle }}</span>
                      <v-spacer></v-spacer>
                      <v-btn icon class="float-right" @click="close()">
                        <v-icon>mdi-window-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text class="py-4 pt-6">
                      <v-form ref="form">
                        <!-- <pre>{{file_image}}</pre> -->
                        <v-row align="center" justify="center" class="py-0">
                          <v-col cols="5" class="py-0">
                            <v-card
                              class="text-center pt-8"
                              height="200"
                              outlined
                              style="border:1px solid rgba(0, 0, 0, 0.38);"
                              v-if="show_img"
                            >
                              <label :for="namephotofile">
                                <center>
                                  <v-icon class="float-center pt-7">mdi-cloud-upload</v-icon>
                                </center>

                                <p class="pt-5 px-3 py-1 text-center">อัปโหลดรูปภาพ</p>
                              </label>
                            </v-card>
                            <v-card
                              class="text-center pa-1"
                              height="200"
                              outlined
                              style="border:1px solid rgba(0, 0, 0, 0.38);"
                              v-if="!show_img"
                            >
                              <!-- <v-card-title class="py-0 pt-1">
                                <v-spacer></v-spacer>
                                <v-btn icon @click="removeImage()">
                                  <v-icon class="float-right">mdi-window-close</v-icon>
                                </v-btn>
                              </v-card-title>-->
                              <v-row align="center">
                                <v-col cols="9" class="px-0">
                                  <img
                                    v-for="(img,i) in file_image"
                                    :key="i"
                                    :src="img.thumb"
                                    width="140px"
                                    height="165px"
                                  />
                                </v-col>
                                <v-col cols="3" class="px-0">
                                  <v-btn icon @click="removeImage()">
                                    <v-icon>mdi-window-close</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card>
                            <file-upload
                              class="btn btn-primary dropdown-toggle"
                              input-id="photofile"
                              :directory="directory"
                              :accept="acceptphoto"
                              :extensions="extensionsphoto"
                              :size="size || 0"
                              :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
                              :headers="headers"
                              :data="data"
                              @input-filter="inputFilter"
                              v-model="file_image"
                              @input-file="inputFile"
                              ref="book_media"
                            ></file-upload>
                            <p
                              v-if="file_image==''"
                              class="pa-0"
                              style="color:red; font-size:12px; margin-top:-7%;"
                            >* กรุณาใส่รูปภาพ</p>
                          </v-col>
                          <v-col cols="7" class="py-0 mt-2">
                            <v-text-field
                              class="mt-2"
                              v-model="book.book_name"
                              label="ชื่อหนังสือ"
                              outlined
                              :rules="rule_empthy"
                              required
                            ></v-text-field>
                            <v-text-field
                              v-model="book.book_price"
                              label="ราคา"
                              type="number"
                              outlined
                              :rules="price_rulse"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-textarea
                          v-model="book.book_detail"
                          :rules="rule_empthy"
                          required
                          label="รายละเอียด"
                          outlined
                        ></v-textarea>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" text @click="close">ยกเลิก</v-btn>
                      <v-btn
                        color="primary"
                        type="submit"
                        :loading="click"
                        text
                        @click=" save()"
                      >บันทึก</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <!-- detail in dataTable -->
              <template v-slot:item.no="{ item }">{{ detail_book.indexOf(item) + 1 }}.</template>
              <template v-slot:item.book_name="{ item }">{{ showString(item.book_name,40) }}</template>
              <template v-slot:item.book_detail="{ item }">{{ showString(item.book_detail,70) }}</template>
              <template v-slot:item.image="{ item }">
                <v-card tile class="ma-1">
                  <v-img :src="env+'/'+item.book_file_path" aspect-ratio="1"></v-img>
                </v-card>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click="dialogAddEdit(item) ">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="deleteData(item.book_id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-btn
              class="ma-2 d-block d-sm-none"
              fab
              color="secondary"
              bottom
              dark
              fixed
              right
              @click="dialog = !dialog"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card>
        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog_book_setting = false">cancel</v-btn>
          <v-btn color="success" @click="dialog_book_setting = false">save</v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FileUpload from "vue-upload-component";
export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      click: false,
      show_img: true,
      rule_empthy: [(v) => !!v || "กรุณากรอกข้อมูล"],
      price_rulse: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => /^[0-9]+$/.test(v) || "กรุณาจำนวนให้ถูกต้อง",
        (v) => v >= 0 || "ราคาต้องมากกว่าหรือเท่ากับ 0 บาท",
        (v) =>
          (v ? (v == 0 ? true : v[0] != "0") : true) ||
          "ราคาไม่ควรเริ่มด้วย'0'",
        (v) => v.length < 7 || "ข้อมูลมีความยาวมากเกินไป",
      ],
      env: process.env.VUE_APP_API,
      formTitle: "",
      dialog_book_setting: false,
      dialog: false,
      book_headers: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "รูปภาพ",
          value: "image",
          sortable: false,
          align: "center",
          width: "15%",
        },
        {
          text: "ชื่อหนังสือ",
          value: "book_name",
          sortable: false,
          align: "left",
          width: "20%",
        },
        {
          text: "รายละเอียด",
          value: "book_detail",
          sortable: false,
          align: "left",
          width: "35%",
        },
        {
          text: "ราคา",
          value: "book_price",
          sortable: false,
          align: "left",
          width: "10%",
        },
        {
          text: "จัดการ",
          value: "action",
          sortable: false,
          align: "center",
          width: "5%",
        },
      ],
      book: {
        book_name: "",
        book_detail: "",
        book_price: "",
      },
      minSize: 1024,
      size: 1024 * 1024 * 10,
      acceptphoto: "image/png,image/gif,image/jpeg,image/jpg", //,video/mp4,video/x-m4v,video/*
      extensionsphoto: "gif,jpg,jpeg,png",
      directory: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: 1024 * 1024,
      uploadAuto: true,
      namephotofile: "photofile",
      file_image: [],
      book_list: [],
      detail_book: [],
      editedIndex: -1,
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      delete_file_back: "",
      image_file_back_id: "",
    };
  },
  created() {
    this.getBookDetail();
  },
  methods: {
    openSetting() {
      this.dialog_book_setting = true;
    },
    inputFile(newFile) {},
    inputFilter(newFile, oldFile, prevent) {
      this.show_img = false;
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    removeImage() {
      this.$refs.book_media.remove(this.file_image[0]);
      this.show_img = true;
      if (this.editedIndex > -1) {
        this.delete_file_back = "delete";
      }
    },
    getBookDetail() {
      let book_detail = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/book_all")
        .then((response) => {
          // console.log(response.data);
          book_detail = response.data;

          this.detail_book = book_detail;
        });
    },
    close() {
      this.click = false;

      this.$refs.book_media.remove(this.file_image[0]);
      this.show_img = true;

      this.delete_file_back = "";
      this.dialog = false;
      this.editedIndex = -1;
    },
    dialogAddEdit(item) {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      if (item == "") {
        //add
        this.editedIndex = -1;
        this.formTitle = "เพิ่มหนังสือขาย";
        (this.file_image = []),
          (this.book = {
            book_name: "",
            book_detail: "",
            book_price: "",
          }),
          (this.dialog = true);
      } else if (item.book_id >= 0) {
        //edit
        this.show_img = false;
        this.editedIndex = item.book_id;
        this.formTitle = "แก้ไขหนังสือขาย";
        this.image_file_back_id = item.book_file_id;
        (this.file_image = [{ thumb: this.env + "/" + item.book_file_path }]),
          (this.book = {
            book_name: item.book_name,
            book_detail: item.book_detail,
            book_price: item.book_price,
          });
        this.dialog = true;
      }
    },

    save() {
      if (this.$refs.form.validate() && this.$refs.book_media.files != "") {
        if (this.editedIndex > -1) {
          this.putBook(this.editedIndex);
        } else {
          this.click = true;
          this.postBook();
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาตรวจสอบไฟล์ภาพ หรือ ข้อมูล",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
    postBook() {
      let data = this.book;
      if (this.file_image != []) {
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/book",
            data,
            this.header_token
          )
          .then((response) => {
            let book_id = "";
            book_id = response.data.bookid;
            if (response.data.bookid) {
              this.postBookFile(book_id);
            }
          });
      }
    },
    putBook(id) {
      let data = this.book;
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/book/" + id,
          data,
          this.header_token
        )
        .then((response) => {
          if (response.data == "edit success") {
            if (this.delete_file_back == "delete") {
              this.axios
                .delete(
                  process.env.VUE_APP_API +
                    "/api/v1/book_file/" +
                    this.image_file_back_id,
                  this.header_token
                )
                .then((response) => {
                  if (response.data == "delete success") {
                    this.postBookFile(id);
                  }
                });
            } else {
              this.success();
            }
          } else {
            this.fail();
          }
        });
    },
    postBookFile(id) {
      let form = new FormData();
      if (this.file_image.length != 0) {
        for (let i = 0; i < this.file_image.length; i++) {
          form = new FormData();
          form.append("file", this.file_image[i].file);
          this.axios
            .post(
              process.env.VUE_APP_API + "/api/v1/book_file/" + id,
              form,
              this.header_token
            )
            .then((response) => {
              if (response.data == "upload success") {
                this.success();
              } else {
                this.fail();
              }
              form = new FormData();
            });
        }
      }
    },
    success() {
      this.$swal.fire({
        icon: "success",
        title: "เพิ่มข้อมูลสำเร็จ",
        showConfirmButton: false,
        timer: 1000,
      });
      this.click = false;
      this.getBookDetail();
      this.close();
      this.$emit("getBook", "add");
    },
    fail() {
      this.$swal.fire({
        icon: "error",
        title: "ไม่สามารถเพิ่มข้อมูลได้",
        showConfirmButton: false,
        timer: 1000,
      });
      this.getBookDetail();
      this.close();
    },
    deleteData(id) {
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            // console.log(id);

            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/book/" + id,
                this.header_token
              )
              .then((response) => {
                if (response.data) {
                  if (response.data === "delete success") {
                    this.$swal.fire({
                      icon: "success",
                      title: "ลบข้อมูลสำเร็จ",
                      showConfirmButton: false,
                      timer: 1000,
                    });
                    this.getBookDetail();
                    this.$emit("getBook", "delete");
                  } else {
                    this.$swal.fire("ไม่สามารถลบได้", "", "error");
                  }
                }
              });
          }
        });
    },
    showString(str, length) {
      // parameter invalid
      if (!str) return " ";
      if (!length) return str;
      // parameter is validate
      if (str.length > length) return str.substring(0, length) + "...";
      else return str;
    },
  },
};
</script>